import {
  IonContent,
  IonList,
  IonMenu,
  IonNote,
} from '@ionic/react';

import {
  homeOutline,
  homeSharp,
  chatboxEllipsesOutline,
  receiptOutline, 
  receiptSharp, 
  alertCircleOutline, 
  alertCircleSharp, 
  briefcaseOutline, 
  briefcaseSharp, 
  helpOutline, 
  helpSharp, 
  personCircleOutline, 
  personCircleSharp,
  logOutOutline,
  logOutSharp,
  chatboxEllipsesSharp
} from 'ionicons/icons';


import './Menu.css';
import HeaderMenu from './HeaderMenu';
import MenuType from './MenuType/MenuType';


interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

const appPages1: AppPage[] = [
  {
    title: 'Inicio',
    url: '/',
    iosIcon: homeOutline,
    mdIcon: homeSharp
  },
  {
    title: 'PQRS',
    url: '/pqrs',
    iosIcon: chatboxEllipsesOutline,
    mdIcon: chatboxEllipsesSharp
  },
  {
    title: 'Encuestas',
    url: '/encuestas',
    iosIcon: receiptOutline,
    mdIcon: receiptSharp
  },
  {
    title: 'Botón SOS',
    url: '/boton-sos',
    iosIcon: alertCircleOutline,
    mdIcon: alertCircleSharp
  },
  {
    title: 'Conozca las soluciones Mastin',
    url: '/servicios',
    iosIcon: briefcaseOutline,
    mdIcon: briefcaseSharp
  },
  {
    title: 'Preguntas frecuentes',
    url: '/preguntas-frecuentes',
    iosIcon: helpOutline,
    mdIcon: helpSharp
  },
  {
    title: 'Perfil',
    url: '/perfil',
    iosIcon: personCircleOutline,
    mdIcon: personCircleSharp
  },
  {
    title: 'Términos y condiciones',
    url: '/terminos-y-condiciones',
    iosIcon: receiptOutline,
    mdIcon: receiptSharp
  },
  {
    title: 'Cerrar sesión',
    url: '/logout',
    iosIcon: logOutOutline,
    mdIcon: logOutSharp
  }
];

// const appPages2: AppPage[] = [
//   {
//     title: 'Inicio',
//     url: '/',
//     iosIcon: homeOutline,
//     mdIcon: homeSharp
//   },
//   {
//     title: 'PQRS',
//     url: '/pqrs',
//     iosIcon: chatboxEllipsesOutline,
//     mdIcon: chatboxEllipsesSharp
//   },
//   {
//     title: 'Encuestas',
//     url: '/encuestas',
//     iosIcon: receiptOutline,
//     mdIcon: receiptSharp
//   },
//   {
//     title: 'Nuestras soluciones',
//     url: '/servicios',
//     iosIcon: briefcaseOutline,
//     mdIcon: briefcaseSharp
//   },
//   {
//     title: 'Preguntas frecuentes',
//     url: '/preguntas-frecuentes',
//     iosIcon: helpOutline,
//     mdIcon: helpSharp
//   },
//   {
//     title: 'Perfil',
//     url: '/perfil',
//     iosIcon: personCircleOutline,
//     mdIcon: personCircleSharp
//   },
//   {
//     title: 'Términos y condiciones',
//     url: '/terminos-y-condiciones',
//     iosIcon: receiptOutline,
//     mdIcon: receiptSharp
//   },
//   {
//     title: 'Cerrar sesión',
//     url: '/logout',
//     iosIcon: logOutOutline,
//     mdIcon: logOutSharp
//   }
// ];

//const Menu: React.FC = () => {
const Menu = () => {
  /*-------------- Llamar los datos del perfil -----------------*/
  const data = localStorage.getItem('profile') as string;
  const profile = JSON.parse(data);

  if (localStorage.getItem('token')) {
    return (
      <IonMenu contentId="main" type="overlay">
        <HeaderMenu pageName='Menú' />
        <IonContent>
          <IonList id="inbox-list">
            <div className='user-data-menu-div'>
              <IonNote className='user-data-menu'>
                <h5>{profile.full_name}</h5>
                {profile.email}
                <hr />
              </IonNote>
            </div>

            <MenuType appPages={appPages1} />

          </IonList>
        </IonContent>
      </IonMenu>
    );      
    }
    else {
      return (
        <></>
      );
    }
};

export default Menu;
